"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Snotify default configuration object
 * @type {SnotifyDefaults}
 */
exports.SnotifyConfig = {
    global: {
        newOnTop: true,
        maxOnScreen: 8,
        maxAtPosition: 8,
        filterDuplicates: false
    },
    toast: {
        type: 'simple',
        showProgressBar: false,
        timeout: 3000,
        closeOnClick: true,
        pauseOnHover: true,
        bodyMaxLength: 150,
        titleMaxLength: 16,
        backdrop: -1,
        icon: null,
        iconClass: null,
        html: null,
        position: 'rightTop',
        animation: { enter: 'fadeIn', exit: 'fadeOut', time: 400 }
    },
    type: {
        ['prompt']: {
            timeout: 0,
            closeOnClick: false,
            buttons: [
                { text: 'OK', action: null, bold: true },
                { text: 'Cancel', action: null, bold: false },
            ],
            placeholder: 'Enter answer here...',
            type: 'prompt',
        },
        ['confirm']: {
            timeout: 0,
            closeOnClick: false,
            buttons: [
                { text: 'OK', action: null, bold: true },
                { text: 'Cancel', action: null, bold: false },
            ],
            type: 'confirm',
        },
        ['simple']: {
            type: 'simple'
        },
        ['success']: {
            type: 'success'
        },
        ['error']: {
            type: 'error'
        },
        ['warning']: {
            type: 'warning'
        },
        ['info']: {
            type: 'info'
        },
        ['async']: {
            pauseOnHover: false,
            closeOnClick: false,
            timeout: 0,
            showProgressBar: false,
            type: 'async'
        }
    }
};
